import {Clipboard} from '@angular/cdk/clipboard';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

import {ApiResponse, BaseComponent, DamElasticDTO, FileService} from 'compob2b-libs';
import {map, takeUntil, tap} from 'rxjs/operators';
import {DamPreviewImageComponent} from '../dam-preview-image/dam-preview-image.component';
import {DamPreviewTextComponent} from '../dam-preview-text/dam-preview-text.component';
import {DamPreviewVideoComponent} from '../dam-preview-video/dam-preview-video.component';

@Component({
  selector: 'app-dam-content',
  templateUrl: './dam-content.component.html',
  styleUrls: ['./dam-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamContentComponent extends BaseComponent {

  @Input() data: DamElasticDTO;
  info = false;
  @Output() changeInfo = new EventEmitter<boolean>();

  constructor(
    private readonly fileService: FileService,
    private readonly clipboard: Clipboard
  ) {
    super();
  }

  previewText() {
    this.compoApiService.get<string>('/dam/item/preview-text/' + +this.data.id)
      .pipe(map(response => response.data), takeUntil(this.unsubscribe)).subscribe(data => this.handlePreviewTextContent(data));

  }

  previewImage() {
    this.dialogService.open(DamPreviewImageComponent, {
      context: {id: this.data.id}
    });
  }

  previewVideo() {
    this.dialogService.open(DamPreviewVideoComponent, {
      context: {uid: this.data.syncUid, type: this.data.mimeType, version: this.data.currentDamItemVersionId}
    });
  }

  openDeletePopup() {
    this.confirm('Вы точно хотите удалить файл?', this.compoApiService.delete<ApiResponse<string>>('/dam/item/' + this.data.id).pipe(tap(_ => window.location.reload())));
  }

  private handlePreviewTextContent(data: string) {
    this.dialogService.open(DamPreviewTextComponent, {
      context: {text: data}
    });
  }

  public download(): void {
    this.fileService.downloadUrl('/dam-download/dam-item/' + this.data.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        FileService.saveAs(response, this.data.header + '.zip');
      });

    // this.fileService.downloadUrl('/dam/download/' + this.data.id)
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe(response => {
    //     FileService.saveAs(response, this.data.header);
    //   });
  }

  public copyLink() {
    const url = encodeURI(this.environment.serverDamDocumentsPath + '/' + this.data.previewImage);
    this.clipboard.copy(url);
  }

  public edit(): void {
    this.router.navigate(['cabinet', 'dam', 'item', 'edit', this.data.id]);
  }

  public showInfo() {
    this.info = !this.info;
    this.changeInfo.emit(this.info);
  }
}
